<div class="common-button-wrapper">
	<button class="rectangle" (click)="onClick()" appEheAnalytics [data]="analyticsData">
		<span class="label">{{ buttonTextKey | translate }}</span>
	</button>
</div>
